import { render, staticRenderFns } from "./NotificationNotipayViewPage.vue?vue&type=template&id=fcbb6998"
import script from "./NotificationNotipayViewPage.vue?vue&type=script&lang=js"
export * from "./NotificationNotipayViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports